export const domainName = "https://voucher.overnightflowers.com";
export const apiURL = domainName + "/api/";
export const apiKey = "51ec77e35e6ddb56051bdab12fa9fd36b86d42e8175a48a10f8abfc701013b6c";
export const GACode = 'UA-148533030-2';

export const squareApplicationId = "sq0idp-SxqnBl0h9gTfwE8Rb3PHoQ";
export const squareLocationId = "7MNXFRX37QMEH";